"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportRiskTargetsContextProvider = void 0;
var React = require("react");
var utils_1 = require("../../utils");
var urls_1 = require("../../urls");
var initialState = {
    isOpen: false,
    isReady: false,
    project_choices: [],
    selected_project: undefined,
    target_choices: [],
    selected_targets: [],
};
var ImportRiskTargetsContext = React.createContext(__assign(__assign({}, initialState), { openDialog: undefined, closeDialog: undefined, onProjectSelect: undefined, onRiskTargetsSelect: undefined, onSave: undefined }));
exports.default = ImportRiskTargetsContext;
var ImportRiskTargetsContextProvider = (function (_super) {
    __extends(ImportRiskTargetsContextProvider, _super);
    function ImportRiskTargetsContextProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = __assign({}, initialState);
        return _this;
    }
    ImportRiskTargetsContextProvider.prototype.fetchChoices = function (project_id) {
        var self = this;
        return $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_import_risktargets, this.props.project_id), {
            type: "GET",
            contentType: "application/json",
            data: { project_id: project_id }
        }).done(function (result) {
            self.setState({
                project_choices: [utils_1.emptyChoice].concat(result.project_choices),
                target_choices: result.target_choices,
                isReady: true,
            });
        });
    };
    ImportRiskTargetsContextProvider.prototype.openDialog = function () {
        this.setState({
            isOpen: true,
            isReady: false,
        });
        this.fetchChoices();
    };
    ImportRiskTargetsContextProvider.prototype.closeDialog = function () {
        this.setState({
            isOpen: false,
            isReady: false,
            selected_project: undefined,
            selected_targets: [],
            target_choices: [],
        });
    };
    ImportRiskTargetsContextProvider.prototype.onProjectSelect = function (project_id) {
        var id_ = parseInt(project_id);
        if (isNaN(id_)) {
            this.setState({
                selected_project: null,
                target_choices: [],
            });
        }
        else {
            this.setState({
                selected_project: project_id
            });
            this.fetchChoices(id_);
        }
    };
    ImportRiskTargetsContextProvider.prototype.onRiskTargetsSelect = function (checked) {
        this.setState({
            selected_targets: checked,
        });
    };
    ImportRiskTargetsContextProvider.prototype.onSave = function () {
        var self = this;
        return $.ajax((0, urls_1.resolve)(urls_1.Urls.admin_import_risktargets, this.props.project_id), {
            type: "POST",
            data: JSON.stringify({
                other_project: this.state.selected_project,
                selected_targets: this.state.selected_targets,
            }),
            dataType: "json",
            contentType: "application/json"
        }).done(function () {
            return self.setState({
                isOpen: false,
                isReady: false,
                selected_project: null,
                project_choices: [],
                target_choices: [],
            });
        });
    };
    ImportRiskTargetsContextProvider.prototype.render = function () {
        return (React.createElement(ImportRiskTargetsContext.Provider, { value: __assign(__assign({}, this.state), { openDialog: this.openDialog.bind(this), closeDialog: this.closeDialog.bind(this), onProjectSelect: this.onProjectSelect.bind(this), onRiskTargetsSelect: this.onRiskTargetsSelect.bind(this), onSave: this.onSave.bind(this) }) }, this.props.children));
    };
    return ImportRiskTargetsContextProvider;
}(React.Component));
exports.ImportRiskTargetsContextProvider = ImportRiskTargetsContextProvider;
